import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useMutation } from 'components/graphql'
import { Modal } from 'components/Modal'
import Button from 'components/Button'
import { TextArea } from 'components/forms'
import sendVirtualCardInvitation from '../../gql/sendVirtualCardInvitation'

const SendMessageButton = ({ itemId, link, company }) => {
	const [t] = useTranslation()
	const [messageText, setMessageText] = useState(
		t('loyalty_card_section.strings.invite_message_placeholder', {
			link: 'https://shortlink.hssoft.com/walletCard',
			company
		})
	)
	const [showModal, setShowModal] = useState(null)
	const [sendInvitation] = useMutation(sendVirtualCardInvitation, {
		variables: { id: itemId }
	})
	const handleSubmit = () => {
		sendInvitation({
			variables: {
				id: itemId,
				message: messageText
			}
		})
		setShowModal(false)
	}
	return(
		<>
			<Button text={t('loyalty_card_section.strings.resendInvitation')} onClick={() => setShowModal(true)} style={{
				width: '150px',
				padding: 'unset',
				minWidth: 'unset'
			}}/>
			{showModal && <Modal
				width={340}
				unmount={() => setShowModal(false)}
				label={t('loyalty_card_section.strings.sms-invitation')}
				style={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center'
				}}
			>
				<TextArea
					style={{ height: '400px' }}
					noForm
					value={messageText}
					onChange={(e) => setMessageText(e.target.value)}
				/>
				<Button text={t('common.buttons.send')} onClick={handleSubmit}/>
			</Modal>}
		</>
	)
}

export default SendMessageButton